(self["webpackChunk"] = self["webpackChunk"] || []).push([[6334],{

/***/ 65418:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

__webpack_require__(3020);module.exports = "../../app/cells/components/campaigns/interventions/modal_side_hero/show.erb";

/***/ }),

/***/ 42364:
/***/ ((module) => {

module.exports = "../../app/cells/components/campaigns/interventions/modal_side_hero_cell.rb";

/***/ }),

/***/ 44481:
/***/ ((module) => {

module.exports = "../../app/cells/components/modals/account_limit_free_modal/campaign_modal.erb";

/***/ }),

/***/ 27353:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

__webpack_require__(31654);
__webpack_require__(59406);module.exports = "../../app/cells/components/modals/account_limit_free_modal/show.erb";

/***/ }),

/***/ 11769:
/***/ ((module) => {

module.exports = "../../app/cells/components/modals/account_limit_free_modal_cell.rb";

/***/ }),

/***/ 25624:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

__webpack_require__(31654);module.exports = "../../app/cells/components/modals/account_limit_free_modal/modal_content.erb";

/***/ }),

/***/ 64746:
/***/ ((module) => {

module.exports = "../../app/cells/components/modals/login_register_modal/account_create_modal.erb";

/***/ }),

/***/ 96794:
/***/ ((module) => {

module.exports = "../../app/cells/components/modals/login_register_modal/show.erb";

/***/ }),

/***/ 88473:
/***/ ((module) => {

module.exports = "../../app/cells/components/modals/login_register_modal/login_modal.erb";

/***/ }),

/***/ 71261:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

__webpack_require__(10083);module.exports = "../../app/cells/components/modals/not_subscribed_user_modal/show.erb";

/***/ }),

/***/ 9570:
/***/ ((module) => {

module.exports = "../../app/cells/components/modals/not_subscribed_user_modal_cell.rb";

/***/ }),

/***/ 56392:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ applyCountdown)
/* harmony export */ });
function applyCountdown({ selector, template, onFinish = ()=>{} }) {
    vendorManager.ensure('jquery.countdown', ()=>{
        const countdown = window.jQuery(selector);
        if (countdown && countdown.length > 0) {
            if (countdown.length === 1) {
                const finalDate = countdown.data('value');
                countdown.countdown(finalDate).on('update.countdown', function(event) {
                    window.jQuery(this).html(event.strftime(template));
                }).on('finish.countdown', onFinish);
            } else {
                countdown.each(function(_, el) {
                    const countdownEl = window.jQuery(el);
                    const finalDate = countdownEl.data('value');
                    countdownEl.countdown(finalDate).on('update.countdown', function(event) {
                        window.jQuery(this).html(event.strftime(template));
                    }).on('finish.countdown', onFinish);
                });
            }
        }
    });
}


/***/ }),

/***/ 87322:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _serialize_object__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(49539);
/* harmony import */ var _serialize_object__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_serialize_object__WEBPACK_IMPORTED_MODULE_0__);

class ModalManager {
    static bindForm($modal, callback) {
        const $form = window.jQuery('form', $modal);
        if (!$form.length) {
            return;
        }
        $form.off('submit.form').on('submit.form', (e)=>{
            e.preventDefault();
            const formData = $form.serializeObject();
            $modal.modal('hide');
            callback(formData, window.jQuery(e.currentTarget));
            $form.clearForm();
        });
    }
    static populate(selector, data) {
        const $modalElement = selector.jquery ? selector : window.jQuery(selector);
        for(const itemName in data){
            const $element = $modalElement.find(`[data-modal-${itemName}]`);
            const value = data[itemName];
            if ($element.is('button')) {
                value ? $element.show() : $element.hide();
            }
            if ($element.attr('value') !== undefined) {
                $element.val(value);
            } else {
                $element.html(value);
            }
        }
    }
    static bindButtons($modal, callback) {
        window.jQuery('#js-ok-btn', $modal).off('click').on('click', (e)=>{
            e.preventDefault();
            $modal.modal('hide');
            if (callback && typeof callback === 'function') {
                callback(true);
            }
        });
        window.jQuery('#js-cancel-btn', $modal).off('click').on('click', (e)=>{
            e.preventDefault();
            $modal.modal('hide');
            if (callback && typeof callback === 'function') {
                callback(false);
            }
        });
    }
    static dispatchEvents(selector) {
        const eventName = {
            '#modal-id': 'event name'
        }[selector];
        if (eventName === undefined) {
            return;
        }
        UserTracker.emit('event', {
            eventName
        });
    }
    static open(selector, callback) {
        const $modalElement = selector.jquery ? selector : window.jQuery(selector);
        const $modal = $modalElement.modal();
        const isCallbackEnabled = callback && typeof callback === 'function';
        if (isCallbackEnabled) {
            ModalManager.bindForm($modal, callback);
        }
        ModalManager.bindButtons($modal, isCallbackEnabled ? callback : null);
        ModalManager.dispatchEvents(selector);
        $modal.modal('show');
        return $modal;
    }
    static close($modal) {
        $modal.modal('hide');
    }
}
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (ModalManager);


/***/ }),

/***/ 49024:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ permissions_feedbacks)
});

// EXTERNAL MODULE: ./components/modals/account_limit_free_modal/campaign_modal.erb
var campaign_modal = __webpack_require__(44481);
// EXTERNAL MODULE: ./components/modals/account_limit_free_modal/index.erb
var account_limit_free_modal = __webpack_require__(27353);
// EXTERNAL MODULE: ./components/modals/account_limit_free_modal/index.rb
var modals_account_limit_free_modal = __webpack_require__(11769);
// EXTERNAL MODULE: ./components/modals/account_limit_free_modal/modal_content.erb
var modal_content = __webpack_require__(25624);
;// CONCATENATED MODULE: ./components/modals/account_limit_free_modal/index.js





// EXTERNAL MODULE: ./components/modals/account_not_confirm_modal/index.scss
var account_not_confirm_modal = __webpack_require__(83581);
;// CONCATENATED MODULE: ./components/modals/account_not_confirm_modal/index.js

(function($) {
    'use strict';
    const sendEmail = ($button)=>{
        Thor.User.send_email_confirmation({
            user_id: currentUser.id
        }, {}).then(()=>{
            $button.parent().html($button.data('already-sent'));
        });
    };
    $(document).on('click', '.js-btn-resend-email', (event)=>{
        event.preventDefault();
        event.stopPropagation();
        const $button = $(event.currentTarget);
        sendEmail($button);
    });
})(window.jQuery);

// EXTERNAL MODULE: ./components/campaigns/interventions/modal_side_hero/index.erb
var modal_side_hero = __webpack_require__(65418);
// EXTERNAL MODULE: ./components/campaigns/interventions/modal_side_hero/index.rb
var interventions_modal_side_hero = __webpack_require__(42364);
;// CONCATENATED MODULE: ./components/campaigns/interventions/modal_side_hero/index.js



// EXTERNAL MODULE: ./images/login_register_modal/halfpage-modal-360.jpg
var halfpage_modal_360 = __webpack_require__(10089);
// EXTERNAL MODULE: ./images/login_register_modal/halfpage-modal-400.jpg
var halfpage_modal_400 = __webpack_require__(87758);
// EXTERNAL MODULE: ./components/modals/login_register_modal/account_create_modal.erb
var account_create_modal = __webpack_require__(64746);
// EXTERNAL MODULE: ./components/modals/login_register_modal/images/questions.png
var questions = __webpack_require__(35496);
// EXTERNAL MODULE: ./components/modals/login_register_modal/images/statistics.png
var statistics = __webpack_require__(49304);
// EXTERNAL MODULE: ./components/modals/login_register_modal/index.erb
var login_register_modal = __webpack_require__(96794);
// EXTERNAL MODULE: ./components/modals/login_register_modal/index.scss
var modals_login_register_modal = __webpack_require__(57312);
// EXTERNAL MODULE: ./components/modals/login_register_modal/login_modal.erb
var login_modal = __webpack_require__(88473);
// EXTERNAL MODULE: ./pages/session/components/registration_form/index.scss
var registration_form = __webpack_require__(83654);
// EXTERNAL MODULE: ./utils/floating_labels/index.scss
var floating_labels = __webpack_require__(8149);
;// CONCATENATED MODULE: ./utils/floating_labels/index.js

(function($) {
    'use strict';
    $(()=>{
        $('.js-floating-labels').on('blur', '.form-control', function() {
            const $this = $(this);
            $this.parents('.q-floating-label-wrapper').removeClass('q-floating-label-wrapper--focused');
            if ($this.val() === '') $this.parents('.q-floating-label-wrapper').removeClass('q-floating-label-wrapper--filled');
            else $this.parents('.q-floating-label-wrapper').addClass('q-floating-label-wrapper--filled');
        }).on('focus', '.form-control', function() {
            $(this).parents('.q-floating-label-wrapper').addClass('q-floating-label-wrapper--focused');
        }).find('.form-control').each(function() {
            const $this = $(this);
            let isAutofill = false;
            try {
                isAutofill = $this.is(':-webkit-autofill');
            } catch (e) {
                isAutofill = false;
            }
            if ($this.val() !== '' || isAutofill) $this.parents('.q-floating-label-wrapper').addClass('q-floating-label-wrapper--filled');
        });
    });
})(window.jQuery);

;// CONCATENATED MODULE: ./utils/form_submit_toggle/index.js
class FormSubmitToggle {
    bind() {
        if (this.disableBtn) {
            this.handleSubmitBtn();
            this.$context.on('change', ()=>this.handleSubmitBtn());
        }
        this.$context.on('submit', (e)=>this.beforeSubmit(e));
    }
    handleSubmitBtn() {
        if (this.fieldsAreNotValid()) {
            this.disableSubmit();
        } else {
            this.enableSubmit();
        }
    }
    beforeSubmit(e) {
        if (this.fieldsAreNotValid()) {
            e.preventDefault();
            e.stopPropagation();
        }
    }
    enableSubmit() {
        this.$submitBtn.removeClass('disabled');
    }
    disableSubmit() {
        this.$submitBtn.addClass('disabled');
    }
    fieldsAreNotValid() {
        const invalidInputs = this.$requiredInputs.filter(function() {
            return this.checkValidity() === false;
        });
        return invalidInputs.length === 0 ? false : true;
    }
    constructor(formId, disableBtn){
        this.$context = window.jQuery(formId);
        this.$requiredInputs = this.$context.find('input').filter('[required]');
        this.$submitBtn = this.$context.find('input[type=submit]');
        this.disableBtn = disableBtn;
        this.bind();
    }
}


;// CONCATENATED MODULE: ./pages/session/components/registration_form/index.js



new FormSubmitToggle('#registration_form', true);

;// CONCATENATED MODULE: ./components/modals/login_register_modal/index.js











// EXTERNAL MODULE: ./components/modals/question_belt_block_modal/index.scss
var question_belt_block_modal = __webpack_require__(4381);
;// CONCATENATED MODULE: ./components/modals/question_belt_block_modal/index.js


// EXTERNAL MODULE: ./components/modals/session_expired_modal/index.scss
var session_expired_modal = __webpack_require__(39285);
;// CONCATENATED MODULE: ./components/modals/session_expired_modal/index.js


// EXTERNAL MODULE: ./components/modals/account_limit_questions_modal/index.js
var account_limit_questions_modal = __webpack_require__(24363);
// EXTERNAL MODULE: ./utils/ajax_component_loader/index.js
var ajax_component_loader = __webpack_require__(62346);
// EXTERNAL MODULE: ./utils/modal_manager/index.js
var modal_manager = __webpack_require__(87322);
// EXTERNAL MODULE: ./utils/validator/index.js
var validator = __webpack_require__(91337);
;// CONCATENATED MODULE: ./utils/login_register/index.js
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}




class LoginRegisterModal {
    init() {
        this.btnLogin = window.jQuery('#button-login', this.container);
        this.btnRegister = window.jQuery('#button-register', this.container);
        this.modalRegister = window.jQuery('#modal-register', this.container);
        this.modalLogin = window.jQuery('#modal-login', this.container);
        this.btnLogin.on('click', ()=>{
            this.modalRegister.hide();
            this.modalLogin.show();
        });
        this.btnRegister.on('click', ()=>{
            this.modalRegister.show();
            this.modalLogin.hide();
        });
    }
    initNew() {
        this.btnLogin = window.jQuery('.button-login', this.container);
        this.btnLoginEmail = window.jQuery('.button-login-email', this.container);
        this.btnRegisterEmail = window.jQuery('.button-register-email', this.container);
        this.btnRegisterSocial = window.jQuery('.button-register-social', this.container);
        this.btnRecovery = window.jQuery('#button-recovery', this.container);
        this.btnTogglePassword = window.jQuery('.btn-toggle', this.container);
        this.modalLogin = window.jQuery('#modal-login', this.container);
        this.modalRegister = window.jQuery('#modal-register', this.container);
        this.modalRegisterSocial = window.jQuery('#modal-register-social', this.container);
        this.modalRecovery = window.jQuery('#modal-recovery', this.container);
        this.modalWelcome = window.jQuery('#modal-welcome', this.container);
        // login
        this.btnLogin.on('click', (e)=>{
            e.preventDefault();
            this.modalRegister.addClass('hidden');
            this.modalRegisterSocial.addClass('hidden');
            this.modalRecovery.addClass('hidden');
            this.modalLogin.addClass('hidden');
            this.modalWelcome.removeClass('hidden');
        });
        // login email
        this.btnLoginEmail.on('click', (e)=>{
            e.preventDefault();
            this.modalRegisterSocial.addClass('hidden');
            this.modalRecovery.addClass('hidden');
            this.modalWelcome.addClass('hidden');
            this.modalLogin.removeClass('hidden');
        });
        // back login
        this.modalLogin.find('.close').on('click', ()=>{
            this.modalLogin.addClass('hidden');
            this.modalWelcome.removeClass('hidden');
        });
        // register
        this.btnRegisterEmail.on('click', (e)=>{
            e.preventDefault();
            this.modalLogin.addClass('hidden');
            this.modalRecovery.addClass('hidden');
            this.modalWelcome.addClass('hidden');
            this.modalRegisterSocial.addClass('hidden');
            this.modalRegister.removeClass('hidden');
        });
        // back register
        this.modalRegister.find('.close').on('click', ()=>{
            this.modalRegister.addClass('hidden');
            this.modalRegisterSocial.removeClass('hidden');
        });
        // register social
        this.btnRegisterSocial.on('click', (e)=>{
            e.preventDefault();
            this.modalLogin.addClass('hidden');
            this.modalRegister.addClass('hidden');
            this.modalRecovery.addClass('hidden');
            this.modalWelcome.addClass('hidden');
            this.modalRegisterSocial.removeClass('hidden');
        });
        // recovery
        this.btnRecovery.on('click', (e)=>{
            e.preventDefault();
            this.modalLogin.addClass('hidden');
            this.modalRegister.addClass('hidden');
            this.modalWelcome.addClass('hidden');
            this.modalRecovery.removeClass('hidden');
        });
        // back recovery
        this.modalRecovery.find('.close').on('click', ()=>{
            this.modalRecovery.addClass('hidden');
            this.modalLogin.removeClass('hidden');
        });
        // toggle pass
        this.btnTogglePassword.on('click', ()=>{
            this.btnTogglePassword.parent().find('#user_password').attr('type', this.btnTogglePassword.parent().find('#user_password').attr('type') === 'text' ? 'password' : 'text');
            window.jQuery('.q-icon-eye, .q-icon-eye-off').toggleClass('q-icon-eye-off q-icon-eye');
        });
        // form validator
        validator/* default.init */.Z.init();
        new FormSubmitToggle('#registration_form', true);
    }
    constructor(container, newModal){
        this.container = container;
        newModal ? this.initNew() : this.init();
    }
}
class LoginRegister {
    static newLoginModal(return_url, data = {}) {
        ajax_component_loader/* default.load */.Z.load({
            component: 'modals/login_register_modal',
            type: 'component',
            data: _extends({
                return_url
            }, data)
        }).then((html)=>{
            var _$_data, _$;
            const $loginContainer = window.jQuery('#js-login-register-modal');
            if ($loginContainer.length > 0) {
                $loginContainer.remove();
            }
            window.jQuery('body').append(html);
            const modal = modal_manager/* default.open */.Z.open('#js-login-register-modal');
            new LoginRegisterModal(modal, window.jQuery('#js-login-register-modal').hasClass('q-auth-modal'));
            // tracking events
            if ((_$ = window.jQuery(modal)) == null ? void 0 : (_$_data = _$.data) == null ? void 0 : _$_data.call(_$, 'trackingEvent')) {
                UserTracker.emit('event', {
                    eventName: 'account create paywall opened',
                    data: {
                        request_path: return_url
                    }
                });
            }
            if (data.trackingEvent) {
                UserTracker.emit('event', data.trackingEvent);
            }
        }).catch(()=>{
            Turbolinks.visit(`/conta/entrar?return_url=${return_url}`);
        });
    }
}


// EXTERNAL MODULE: ./components/modals/not_subscribed_user_modal/index.js
var not_subscribed_user_modal = __webpack_require__(11971);
// EXTERNAL MODULE: ./utils/countdown/index.js
var countdown = __webpack_require__(56392);
;// CONCATENATED MODULE: ./utils/permissions/feedbacks.js
function feedbacks_extends() {
    feedbacks_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return feedbacks_extends.apply(this, arguments);
}










const feedbacks = {
    utils: {
        block (event = new Event(null)) {
            event.preventDefault();
            event.stopPropagation();
            event.stopImmediatePropagation();
        },
        openModal (modal) {
            modal_manager/* default.open */.Z.open(`#${modal}`);
        },
        getEventResourceLimitSlug (resource) {
            const eventSlug = {
                question_comments: 'question commentaries',
                question_statistics: 'question statistics',
                question_teacher: 'commented_feedback'
            };
            return eventSlug[resource];
        }
    },
    buildLimitModal: function(dataKey) {
        const modalSeletor = 'js-account-limit-free-modal';
        const $modalBody = window.jQuery(`#${modalSeletor} .modal-content`);
        const data = $modalBody.data(dataKey);
        const imageFallback = $modalBody.data('imageFallback');
        $modalBody.find('a').attr('href', data.cta_link);
        window.jQuery(`#${modalSeletor} .js-benefits-list`).find('li p').each(function(index) {
            window.jQuery(this).html(data.args[index]);
        });
        if ($modalBody.find('[data-modal-image]')) {
            var _data_image;
            $modalBody.find('[data-modal-image]').attr('src', (_data_image = data == null ? void 0 : data.image) != null ? _data_image : imageFallback);
        }
        this.createCloseModalEventProxy(modalSeletor, dataKey);
        modal_manager/* default.populate */.Z.populate(`#${modalSeletor}`, {
            username: currentUser.name,
            title: data.title,
            description: data.description,
            'btn-text': data.btn_text,
            'cta-text': data.cta_text
        });
        const $title = window.jQuery(`#${modalSeletor} [data-title]`);
        if ($title.length > 0) {
            $title.attr('aria-label', data.title);
        }
        this.utils.openModal(modalSeletor);
        (0,countdown/* default */.Z)({
            selector: `#${modalSeletor} .countdown`,
            template: '%H:%M:%S'
        });
    },
    buildBlockQuestionBeltModal () {
        (0,countdown/* default */.Z)({
            selector: '#js-question-belt-block-modal .limit-countdown',
            template: '%H:%M:%S'
        });
        this.createCloseModalEventProxy('js-question-belt-block-modal');
        this.utils.openModal('js-question-belt-block-modal');
    },
    createCloseModalEventProxy (modalSelector, key) {
        window.jQuery(`#${modalSelector}`).off('hidden.bs.modal').on('hidden.bs.modal', ()=>{
            const { showOnQuestionLimitation, showOnModalRestriction, active } = gon.flags.trial_settings;
            if (key === 'modal-questions-content' && active && showOnQuestionLimitation) {
                window.openTrialModal('question_limitation');
            }
            if (modalSelector === 'js-question-belt-block-modal' && active && (showOnQuestionLimitation || showOnModalRestriction)) {
                window.openTrialModal('question_limitation');
            }
            if (key === 'modal-restriction' && active && showOnModalRestriction) {
                window.openTrialModal('modal_restriction');
            }
        });
    },
    account (event, url = location.pathname, data) {
        LoginRegister.newLoginModal(url, data);
        this.utils.block(event);
    },
    confirmed_account (event) {
        this.utils.openModal('js-account-not-confirm-modal');
        this.utils.block(event);
    },
    createNotebookLimit (event) {
        this.buildLimitModal('modal-notebooks-content');
        this._sendAnalytics({
            'resource limited': 'notebooks'
        });
        this.utils.block(event);
    },
    practiceTestLimit (event) {
        this.buildLimitModal('modal-practice-tests-content');
        this._sendAnalytics({
            'resource limited': 'practice tests'
        });
        this.utils.block(event);
    },
    saveFilterLimit (event) {
        this.buildLimitModal('modal-stored-filters-content');
        this._sendAnalytics({
            'resource limited': 'stored filers'
        });
        this.utils.block(event);
    },
    resolveQuestionLimit (event) {
        this.buildLimitModal('modal-questions-content');
        this._sendAnalytics({
            'resource limited': 'questions'
        });
        this.utils.block(event);
    },
    viewCommentaryLimit (event) {
        this.buildLimitModal('modal-question-commentaries-content');
        this._sendAnalytics({
            'resource limited': 'question commentaries'
        });
        this.utils.block(event);
    },
    printQuestionsLimit (event) {
        this.buildLimitModal('modal-questions-print-content');
        this._sendAnalytics({
            'resource limited': 'question printing'
        });
        this.utils.block(event);
    },
    subscription (event) {
        var _event_detail;
        const allowedEvents = [
            'per_page',
            'sort',
            'commented_feedback'
        ];
        if (!allowedEvents.includes(event == null ? void 0 : (_event_detail = event.detail) == null ? void 0 : _event_detail.type)) {
            return;
        }
        new not_subscribed_user_modal/* default */.Z('#js-not-subscribed-user-modal', event.detail.type);
        this.createCloseModalEventProxy('js-not-subscribed-user-modal', 'modal-restriction');
        this.utils.block(event);
    },
    trial (event) {
        var _event_detail;
        const allowedEvents = [
            'commented_feedback'
        ];
        if (!allowedEvents.includes(event == null ? void 0 : (_event_detail = event.detail) == null ? void 0 : _event_detail.type)) {
            return;
        }
        new not_subscribed_user_modal/* default */.Z('#js-not-subscribed-user-modal', event.detail.type);
        this.utils.block(event);
    },
    newQuestionLimitModal (event) {
        this.utils.openModal('js-account-limit-questions-modal');
        this._sendAnalytics({
            'resource limited': 'questions'
        });
        const newQuestionLimitModal = new account_limit_questions_modal/* default */.Z();
        newQuestionLimitModal.load();
        this.utils.block(event);
    },
    questionBeltBlock () {
        this.buildBlockQuestionBeltModal();
        this._sendAnalytics({
            'resource limited': 'questions'
        });
        this.utils.block();
    },
    premium (event) {
        this.utils.openModal('js-not-premium-user-modal');
        this.utils.block(event);
    },
    premiumPlus (event) {
        this.utils.openModal('js-not-premium-plus-user-modal');
        this.utils.block(event);
    },
    black (event) {
        this.utils.openModal('js-not-black-user-modal');
        this.utils.block(event);
    },
    unlimited (event) {
        this.utils.openModal('js-not-unlimited-user-modal');
        this.utils.block(event);
    },
    digitalUnlimited (event) {
        this.utils.openModal('js-not-digital-unlimited-user-modal');
        this.utils.block(event);
    },
    questionBeltLimit (type) {
        this._sendAnalytics({
            'resource limited': this.utils.getEventResourceLimitSlug(type)
        });
        this.utils.block();
    },
    commented_feedback_enabled (event) {
        this.subscription(event);
        this._sendAnalytics({
            'resource limited': 'commented_feedback'
        });
    },
    _sendAnalytics (data = {}) {
        const $bodyEl = window.jQuery('body');
        let eventData = data;
        if ($bodyEl.hasClass('q-route-questions-show')) {
            eventData = feedbacks_extends({}, eventData, {
                source_page: 'show'
            });
        }
        UserTracker.emit('event', {
            eventName: 'account limit reached',
            data: eventData
        });
    }
};
/* harmony default export */ const permissions_feedbacks = (feedbacks);


/***/ }),

/***/ 49539:
/***/ (() => {

/* eslint-disable no-prototype-builtins */ (function($) {
    $.fn.serializeObject = function(castValues = true, alwaysReturnKeys = false) {
        let self = this, json = {}, push_counters = {}, patterns = {
            'validate': /^[a-zA-Z][a-zA-Z0-9_]*(?:\[(?:\d*|[a-zA-Z0-9_]+)\])*$/,
            'key': /[a-zA-Z0-9_]+|(?=\[\])/g,
            'push': /^$/,
            'fixed': /^\d+$/,
            'named': /^[a-zA-Z0-9_]+$/
        };
        this.isJsonString = function(str) {
            try {
                JSON.parse(str);
            } catch (e) {
                return false;
            }
            return true;
        };
        this.castValues = (obj)=>{
            // eslint-disable-next-line no-unused-vars
            for(const key in obj){
                if (!obj.hasOwnProperty(key)) continue;
                let value = obj[key];
                if (typeof value === 'undefined' || value === null || value.toString().length === 0) continue;
                if (typeof value === 'object') {
                    value = this.castValues(value);
                } else if (value === 'true') {
                    value = true;
                } else if (value === 'false') {
                    value = false;
                } else if (!isNaN(value)) {
                    value = parseFloat(value);
                } else if (this.isJsonString(value)) {
                    value = JSON.parse(value);
                }
                obj[key] = value;
            }
            return obj;
        };
        this.build = function(base, key, value) {
            if (alwaysReturnKeys || value && value.toString().length) base[key] = value;
            return base;
        };
        this.push_counter = function(key) {
            if (push_counters[key] === undefined) {
                push_counters[key] = 0;
            }
            return push_counters[key]++;
        };
        $.each($(this).serializeArray(), function() {
            // skip invalid keys
            if (!patterns.validate.test(this.name)) {
                return;
            }
            let k, keys = this.name.match(patterns.key), merge = this.value, reverse_key = this.name;
            while((k = keys.pop()) !== undefined){
                // adjust reverse_key
                reverse_key = reverse_key.replace(new RegExp('\\[' + k + '\\]$'), '');
                if (k.match(patterns.push)) {
                    merge = self.build([], self.push_counter(reverse_key), merge);
                } else if (k.match(patterns.fixed)) {
                    merge = self.build([], k, merge);
                } else if (k.match(patterns.named)) {
                    merge = self.build({}, k, merge);
                }
            }
            json = $.extend(true, json, merge);
        });
        return castValues ? this.castValues(json) : json;
    };
})(window.jQuery);


/***/ }),

/***/ 29483:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ SessionExpired)
/* harmony export */ });
/* harmony import */ var utils_ajax_component_loader__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62346);
/* harmony import */ var utils_modal_manager__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87322);


class SessionExpired {
    static renewSessionModal(return_url) {
        utils_ajax_component_loader__WEBPACK_IMPORTED_MODULE_0__/* ["default"].load */ .Z.load({
            component: 'modals/session_expired_modal',
            type: 'component',
            data: {
                return_url: return_url
            }
        }).then((html)=>{
            window.jQuery('body').append(html);
            if (gon.flags.session_expired_debug) {
                UserTracker.emit('event', {
                    eventName: 'expired session',
                    data: {
                        request_path: window.location.pathname,
                        cookie_my_app_session: Boolean(window.currentUser),
                        cookie_remember_user_token: Boolean(window.currentUser)
                    }
                });
            }
            utils_modal_manager__WEBPACK_IMPORTED_MODULE_1__/* ["default"].open */ .Z.open('#js-session-expired-modal');
        }).catch(()=>{
            Turbolinks.visit(`/conta/entrar?return_url=${return_url}`);
        });
    }
}



/***/ }),

/***/ 91337:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var validate__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2259);
/* harmony import */ var validate__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(validate__WEBPACK_IMPORTED_MODULE_0__);
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}

// https://github.com/cferdinandi/validate/blob/master/package.json
// import and run validate.init();
const defaultConfig = {
    // Classes and Selectors
    selector: '[data-validate]',
    fieldClass: 'has-error',
    errorClass: 'help-block',
    // Messages
    messageValueMissing: 'Campo obrigatório.',
    messageValueMissingSelect: 'Selecione uma opção.',
    messageTypeMismatchEmail: 'Digite um e-mail válido.',
    messageTypeMismatchURL: 'Insira uma URL válida.',
    messageTooShort: 'Deve ter {minLength} caracteres ou mais.',
    messageTooLong: 'Deve ter {maxLength} caracters ou menos. Você está usando {length} caracteres.',
    messagePatternMismatch: 'Formato inválido.',
    messageBadInput: 'Insira apenas números.',
    messageStepMismatch: 'Selecione um valor válido.',
    messageRangeOverflow: 'Selecione um valor acima de {max}.',
    messageRangeUnderflow: 'Selecione um valor abaixo de {min}.',
    messageGeneric: 'Valor inválido.',
    // Custom
    createFeedbackIcon (className) {
        let node = document.createElement('i');
        node.classList.add('form-control-feedback', 'js-form-control-feedback', 'q-icon', `q-icon-${className}`);
        return node;
    },
    // Form Submission
    disableSubmit: false,
    customValidity: {
        badConfirm: {
            check (field) {
                if (!field.hasAttribute('confirm')) return false;
                const value = field.value;
                const fieldToCompare = field.getAttribute('confirm');
                const fieldToCompareValue = field.form.querySelector(`#${fieldToCompare}`).value;
                return value !== fieldToCompareValue;
            },
            message: 'O valor não é igual.'
        }
    },
    // onSubmit() {},
    // Callbacks
    beforeShowError (field) {
        const parent = field.parentNode;
        if (parent.classList.contains('form-group') || parent.classList.contains('input-group')) {
            const formControl = parent.querySelector('.js-form-control-feedback');
            parent.classList.remove('has-success', 'has-error', 'has-warning');
            parent.classList.add('has-error', 'has-feedback');
            if (formControl) formControl.remove();
            parent.appendChild(this.createFeedbackIcon('times-circle'));
        }
    },
    // afterShowError(field, error) {}
    beforeRemoveError (field) {
        const parent = field.parentNode;
        if (parent.classList.contains('form-group') || parent.classList.contains('input-group')) {
            const formControl = parent.querySelector('.js-form-control-feedback');
            parent.classList.remove('has-success', 'has-error', 'has-warning');
            parent.classList.add('has-feedback', 'has-success');
            if (formControl) formControl.remove();
            parent.appendChild(this.createFeedbackIcon('check-circle'));
        }
    }
};
const validator = {
    config: defaultConfig,
    validate: (validate__WEBPACK_IMPORTED_MODULE_0___default()),
    init (config = null) {
        const expandedConfig = _extends({}, defaultConfig, config);
        validate__WEBPACK_IMPORTED_MODULE_0___default().init(expandedConfig);
    }
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (validator);


/***/ }),

/***/ 35496:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "assets/questions-c7505b5a8b7867e6820b.png";

/***/ }),

/***/ 49304:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "assets/statistics-85582dbd5555ce449177.png";

/***/ }),

/***/ 66382:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "assets/thinking-1250b2da95171aa9dfb3.svg";

/***/ }),

/***/ 10089:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "assets/halfpage-modal-360-e326a34ff557e11a157e.jpg";

/***/ }),

/***/ 87758:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "assets/halfpage-modal-400-209a7679e4b3f62f0ac9.jpg";

/***/ }),

/***/ 59406:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
module.exports = __webpack_require__.p + "assets/work-home-dc55687379271c7c0ed1.svg";

/***/ })

}]);